import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=bf20a808&scoped=true&"
import script from "./Page2.vue?vue&type=script&lang=js&"
export * from "./Page2.vue?vue&type=script&lang=js&"
import style0 from "./Page2.vue?vue&type=style&index=0&id=bf20a808&prod&scoped=true&lang=css&"
import style1 from "./Page2.vue?vue&type=style&index=1&id=bf20a808&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf20a808",
  null
  
)

export default component.exports